<div ngDefaultControl>
  <div style="display: flex; align-items: top; gap: 40px">
    <div style="flex: 4">

      <h2 class="cpo-table-title">Merchant Info</h2>
      <div id="merchantInfoContainer" class="tabContent">
        <div class="cpo-section-container paddedContent containerMargins"  *ngIf="allowViewContact">
          <app-merchant-contact 
            [headerText]="''"
            [contacts]="this.merchant ? this.merchant.users : []"
            [merchantId]="this.merchant?.id || ''"
            [enableEditing]="allowEditContact"
            [mode]="FormMode.View"
            (onsave)="handleContactUpdated($event)"
            (ondelete)="handleContactUpdated($event)"
          ></app-merchant-contact>
        </div>

        <div *ngIf="allowViewBusinessInfo" class="cpo-section-container paddedContent containerMargins">
          <merchant-account-info
            [merchant]="this.merchant"
            [enableEditing]="allowEditBusinessInfo"
            [mode]="FormMode.View"
            (saved)="handleSaved($event)"
          >
          </merchant-account-info>
        </div>

        @if (this.merchant && this.merchant.processors.length > 0 && allowViewProcessors) {
          <div class="cpo-section-container paddedContent containerMargins">
            <app-merchant-processors
              [solution]="this.solution"
              [processors]="this.merchant.processors"
              [merchantId]="this.merchant.id"
              [mode]="FormMode.View"
              [enableEditing]="allowEditProcessors"
              (saved)="handleSaved($event)"
            ></app-merchant-processors>
          </div>
        }

        @if (this.merchant?.campfireMerchant.campfire_id != 0) {
          <div class="cpo-section-container paddedContent containerMargins">
            <h2 class="cpo-section-title">Campfire</h2>
            <div style="display: flex; flex-direction: row; justify-content: space-between; flex: 1; padding: 0px 0px 10px">
              <div class="cpo-pod">
                <span class="title">ID</span>
                <span class="r1">{{ this.merchant?.campfireMerchant.campfireId }}</span>
              </div>
              <div class="cpo-pod">
                <span class="title">Payment Link</span>
                <span class="r1">{{ this.merchant?.campfireMerchant.paymentLink }}</span>
              </div>
              <div class="cpo-pod">
                <span class="title">API Key</span>
                <span class="r1">{{ this.merchant?.campfireMerchant.apiKey }}</span>
              </div>
            </div>
          </div>
        }

      </div>


      <div id="ordersContainer" class="tabContent">
        <div
          class="sectionContainer paddedContent containerMargins"
          [hidden]="!merchant"
        >
          <app-merchant-orders-page
            [merchantId]="merchant?.id"
          ></app-merchant-orders-page>
        </div>
      </div>
    </div>
  </div>
